import React, {Fragment, useState, useEffect, useContext} from "react";
import PropTypes from "prop-types";

import './MessagingTab.scss';
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import {getContactMessages} from "root/DataFunctions/MessageDataFns";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import MessagesTable from "root/Tables/MessagesTable";
import {MessageFilters, MessageType} from "root/DataFunctions/Constants";
import {useSetRecoilState} from "recoil";
import {unReadMessageCountAtom} from "root/recoil/unReadMessageCount";
import {returnedMessageCountAtom} from "root/recoil/returnedMessageCount";
import {childNameAtom} from "root/recoil/childName";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";
import useModalApprovePost from "root/Modals/ApprovePost/useModalApprovePost";

const MessagingTab = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: []});
    const setUnReadMessageCount = useSetRecoilState(unReadMessageCountAtom);
    const setReturnedMessageCount = useSetRecoilState(returnedMessageCountAtom);
    const shouldShowToDropdown = false;

    //Get the message default filter, if we don't have child or contact the default is incoming
    //If we have child and user is editor default is new, else default is sent
    const getDefaultFilter = () =>
    {
        if (props.child_uid === undefined && props.contact_uid === undefined){
            //Default to users inbox
            return MessageFilters.INCOMING
        }
        else if(props.contact_uid !== undefined){
            //Default to my sent
            return MessageFilters.SENT
        }
        else if(props.child_uid !== undefined)
        {
            //Check if user is editor for this child
            if(props.is_editor){
                //Default to my sent
                return MessageFilters.NEW
            }
            else{
                //Default to my sent
                return MessageFilters.SENT
            }
        }
    }

    const messageFilterDefault = getDefaultFilter();
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const messageFilter = queryParams.type === undefined ? messageFilterDefault : queryParams.type;

    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        if(result === 'saved'){
            getData();
        }
    })

    const [renderApproveMessagingModal, showApproveMessagingModal] = useModalApprovePost((result) =>
    {
        if(result === 'saved'){
            getData();
        }
    })

    useEffect(() => {
        getData();
    }, [messageFilter, props.child_uid, props.contact_uid]);

    //Get child's data and set the global child name used by the various body header
    const setChildName = useSetRecoilState(childNameAtom);

    useEffect(() => {
        getChildData();
    }, [props.child_uid]);

    const getChildData = () =>{
        if(props.child_uid !== undefined)
        {
            getChildDetails(props.child_uid, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const getMessageTargetUserId = () =>
    {
        if ( props.child_uid !== undefined )
        {
            return props.child_uid ;
        }
        else if ( props.contact_uid !== undefined  )
        {
            return props.contact_uid ;
        }
        else
        {
            throw new Error('Message Tab Cannot create messages without a destination user id') ;
        }
    }

    const getUserContactMessages = ( contact_uid ) =>
    {
        getContactMessages( 'user', contact_uid, messageFilter, MessageType.MESSAGE_TYPE_MESSAGE,(response) =>
        {
            const data = getDataFromResponse(response);
            setData({isLoading: false, data: data});

            //Count any unread/returned messages
            if(messageFilter === MessageFilters.INCOMING && contact_uid == 'user'){
                let counter = 0;
                for (const obj of data) {
                    if (obj.is_read === '0') counter++;
                }

                // Set the recoil unread message Atom
                setUnReadMessageCount(counter);
            }

            //Count any returned messages
            if(messageFilter === MessageFilters.RETURNED){
                const counter = data.length;
                // Set the recoil unread message Atom
                setReturnedMessageCount(counter);
            }
        })
    }

    const getData = () =>
    {
        //Gets messages type Message
        if ( props.child_uid !== undefined )
        {
            getUserContactMessages(props.child_uid) ;
        }
        else if ( props.contact_uid !== undefined  )
        {
            getUserContactMessages(props.contact_uid) ;
        }
        else
        {
            getUserContactMessages('user') ;
        }
    }

    const messageClickHandler = (mode, child_uid, message_id) =>
    {
        switch (mode){
            case 'create':
            case 'view':
            case 'reply':
            case 'edit':
                const page = 'inbox';
                showAddMessagingModal(mode, child_uid, message_id, shouldShowToDropdown, MessageType.MESSAGE_TYPE_MESSAGE, page);
                break;

            case 'Action':
            case 'Hold Back':
                showApproveMessagingModal(mode, child_uid, message_id, MessageType.MESSAGE_TYPE_MESSAGE);
                break;
        }
    }

    const myMessagingTable = () =>
    {
        const target_user_id = props.child_uid !== undefined ? props.child_uid : props.contact_uid ;
        const showCreateMessageButton = props.child_uid !== undefined || props.contact_uid !== undefined ;

        return (
            <Fragment>
                <div className="post-body">
                    <MessagesTable child_uid={target_user_id} unenc_child_uid={props.unenc_child_uid} loading={data.loading} data={data.data} clickHandler={messageClickHandler}/>
                    <section>
                        {/* don't show create button if child not selected */}
                        { showCreateMessageButton === true && <ActionButton icon='icon-add' onClick={() => messageClickHandler('create', getMessageTargetUserId(), null)} title="New Message"/>}
                    </section>
                </div>

                {renderApproveMessagingModal(props)}
                {renderAddMessagingModal(props)}
            </Fragment>
        )
    }

    const tableSection = () =>
    {
        return myMessagingTable();
    }

    return (
        <Fragment>
            {tableSection()}
        </Fragment>
    )
}

MessagingTab.defaultProps = {};

export default MessagingTab;

MessagingTab.propTypes = {
    child_uid: PropTypes.string,            /* For child related messaging this is the user ID of the currently selected child */
    contact_uid: PropTypes.string,      /* For contact related messaging this is the user ID of the currently selected contact */
};
